import "core-js/modules/es.array.find-index";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import vCountDown from '@/mixin/v-countdown';
import { loadScript } from '@tencent/vft-utils';
import MagicService from '../../service/magic';
var loadScriptPromise = null;
var MSG_MAP = {
  0: '秒杀未开始',
  2: '您已经参与过了',
  3: '已经秒杀完了',
  4: '秒杀已经结束'
};
export default {
  name: 'Kill',
  mixins: [vCountDown],
  data: function data() {
    return {
      killInfo: null,
      clientTime: Date.now()
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setState: 'setState'
  })), {}, {
    loadSinglePay: function loadSinglePay() {
      if (loadScriptPromise) return loadScriptPromise;

      if (!window.VftSingleCashier) {
        loadScriptPromise = loadScript('https://vm.gtimg.cn/tencentvideo/script/film/lib/VftSingleCashier.umd.min.js');
      }

      return loadScriptPromise;
    },
    doKill: function doKill() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, key, vm, res, sCode;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.loginService.isLogin) {
                  _context.next = 3;
                  break;
                }

                _this.loginService.openLogin();

                return _context.abrupt("return");

              case 3:
                _this.loading.show();

                _context.prev = 4;
                _context.next = 7;
                return MagicService.doKill();

              case 7:
                result = _context.sent;

                if (result) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                if (!(result.data.is_kill_succ !== 1)) {
                  _context.next = 13;
                  break;
                }

                _this.toast(MSG_MAP[result.data.kill_status] || '秒杀失败');

                return _context.abrupt("return");

              case 13:
                key = result.data.token_key;

                if (key) {
                  _context.next = 17;
                  break;
                }

                _this.toast('支付参数错误');

                return _context.abrupt("return");

              case 17:
                _context.next = 19;
                return _this.loadSinglePay();

              case 19:
                vm = _this;
                window.VftSingleCashier.buy({
                  appid: '1005',
                  // 必填
                  items: String(result.data.goods_id),
                  // 必填
                  remark: key,
                  // 必填
                  hlwofferid: '457309',
                  publicParam: {
                    report_servtype: '4'
                  },
                  onSuccess: function onSuccess(res) {
                    console.log('pay succ, orderid:', res.order_id);
                    vm.paySuccCb(res);
                  },
                  onCancel: function onCancel() {
                    console.log('user canceled...');
                  }
                });
                _context.next = 30;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](4);
                res = _context.t0.res;
                sCode = res && res.security_verify && res.security_verify.code;

                if (sCode === 101) {
                  _this.toast('您的账号存在安全风险，请联系客服处理。');
                } else if (sCode !== 0) {
                  _this.shieldRun(res.security_verify.code, function () {
                    _this.doKill();
                  });
                } else {
                  _this.toast('服务器开小差了');
                }

                _this.loading.hide();

                _this.queryKillInfo();

              case 30:
                _context.prev = 30;

                _this.loading.hide();

                return _context.finish(30);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 23, 30, 33]]);
      }))();
    },
    paySuccCb: function paySuccCb() {
      this.eventBus.$emit('launchShare', {
        action: 'buy',
        type: 'self'
      });
      this.eventBus.$emit('refreshTicketInfo');
      this.queryKillInfo();
    },
    finish: function finish() {
      // 避免重新发请求去服务端，这里重置一下服务器时间
      this.killInfo = _objectSpread(_objectSpread({}, this.killInfo), {}, {
        cur_time: this.killInfo.cur_time + (Date.now() - this.clientTime) / 1000
      });
    },
    queryKillInfo: function queryKillInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return MagicService.getKillInfo();

              case 2:
                res = _context2.sent;

                if (res) {
                  _this2.killInfo = res.data;

                  _this2.setState({
                    state: 'isKillSuccess',
                    value: res.data.kill_status === 2
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    isCurrentKill: function isCurrentKill(item) {
      if (!item || !this.killInfo) return false;
      var now = this.killInfo.cur_time;
      return item.start_time <= now && item.end_time >= now;
    }
  }),
  computed: {
    curKillItemIndex: function curKillItemIndex() {
      var killInfo = this.killInfo;
      if (!killInfo || !killInfo.kill_list) return null;
      return killInfo.kill_list.findIndex(this.isCurrentKill);
    },
    curKillItem: function curKillItem() {
      var killInfo = this.killInfo;
      if (!killInfo || !killInfo.kill_list) return null;
      return killInfo.kill_list[this.curKillItemIndex];
    },
    nextKillItemIndex: function nextKillItemIndex() {
      var _this3 = this;

      var killInfo = this.killInfo;
      if (!killInfo || !killInfo.kill_list) return null;
      var now = killInfo.cur_time;
      return killInfo.kill_list.findIndex(function (item) {
        return !_this3.isCurrentKill(item) && item.start_time > now;
      }) || 0;
    },
    nextKillItem: function nextKillItem() {
      var killInfo = this.killInfo;
      if (!killInfo || !killInfo.kill_list) return null;
      return killInfo.kill_list[this.nextKillItemIndex];
    },
    showKillItem: function showKillItem() {
      return this.curKillItem || this.nextKillItem;
    },
    nextTimeOffset: function nextTimeOffset() {
      if (!this.nextKillItem) return 0;
      return (this.nextKillItem.start_time - this.killInfo.cur_time) * 1000;
    },
    preKillItem: function preKillItem() {
      return this.killInfo && this.killInfo.kill_list[this.nextKillItemIndex - 1];
    },
    // 前一场是不是今天
    preKillItemIsToady: function preKillItemIsToady() {
      if (!this.showKillItem) return false;
      var preKillItem = this.preKillItem;
      if (!preKillItem) return false;
      var now = this.killInfo.cur_time; // eslint-disable-next-line camelcase

      var end_time = preKillItem.end_time; // eslint-disable-next-line camelcase

      return !this.isCurrentKill(preKillItem) && new Date(end_time * 1000).getDate() === new Date(now * 1000).getDate();
    },
    percent: function percent() {
      if (!this.showKillItem) return 0; // eslint-disable-next-line camelcase

      var _this$showKillItem = this.showKillItem,
          left_nums = _this$showKillItem.left_nums,
          total_nums = _this$showKillItem.total_nums; // eslint-disable-next-line camelcase

      return "".concat(Number(left_nums / total_nums * 100).toFixed(2), "%");
    }
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4.eventBus.$on('getKillInfo', _this4.queryKillInfo);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};